import React from 'react';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function PrivacyPage() {
  return <>
      <Navigation data-id="element-271" />

      <main className="wrap report-main" data-id="element-272">
        <article className="report" data-id="element-273">
          {/* frontmatter */}
          <header className="frontmatter" data-id="element-274">
            <div className="fm-cell" data-id="element-275">
              <span className="lbl" data-id="element-276">Document</span>
              <span className="val" data-id="element-277">Privacy Policy</span>
            </div>
            <div className="fm-cell" data-id="element-278">
              <span className="lbl" data-id="element-279">Updated</span>
              <span className="val" data-id="element-280">January 2026</span>
            </div>
            <div className="fm-cell" data-id="element-281">
              <span className="lbl" data-id="element-282">Status</span>
              <span className="val" data-id="element-283">Active</span>
            </div>
          </header>

          {/* HERO */}
          <section className="hero" data-id="element-284">
            <div className="kicker" data-id="element-285">Andoe / Legal</div>
            <h1 data-id="element-286">Privacy Policy</h1>
            <p className="lede" data-id="element-287">
              Andoe ("we", "us", or "our") values your privacy. This Privacy
              Policy explains how we collect, use, share, and protect
              information when you use Andoe, including our website and
              services.
            </p>
            <p className="abstract" data-id="element-288">
              By using Andoe, you agree to the practices described in this
              policy.
            </p>
          </section>

          <section className="report-section" data-id="element-289">
            <div className="section-head" data-id="element-290">
              <div className="section-num" data-id="element-291">01</div>
              <div className="section-title" data-id="element-292">
                <h2 data-id="element-293">Information We Collect</h2>
                <span className="deck" data-id="element-294">Data necessary to operate Andoe.</span>
              </div>
            </div>
            <div className="section-body" data-id="element-295">
              <div className="pad" data-id="element-296"></div>
              <div className="content" data-id="element-297">
                <div className="entry" data-id="element-298">
                  <h3 data-id="element-299">Information you provide</h3>
                  <ul style={{
                  margin: '8px 0',
                  paddingLeft: '20px',
                  color: 'var(--ink-2)',
                  fontSize: '15px'
                }} data-id="element-300">
                    <li data-id="element-301">
                      <strong data-id="element-302">Account information:</strong> name, email address,
                      login credentials
                    </li>
                    <li data-id="element-303">
                      <strong data-id="element-304">Billing information:</strong> when you purchase a
                      plan (processed by our payment processor)
                    </li>
                    <li data-id="element-305">
                      <strong data-id="element-306">Customer content:</strong> prompts, inputs,
                      configuration, and other content you submit
                    </li>
                    <li data-id="element-307">
                      <strong data-id="element-308">Communications:</strong> messages you send to us
                      (support, feedback, inquiries)
                    </li>
                  </ul>
                </div>
                <div className="entry" data-id="element-309">
                  <h3 data-id="element-310">Information collected automatically</h3>
                  <ul style={{
                  margin: '8px 0',
                  paddingLeft: '20px',
                  color: 'var(--ink-2)',
                  fontSize: '15px'
                }} data-id="element-311">
                    <li data-id="element-312">
                      <strong data-id="element-313">Usage data:</strong> pages visited, features used,
                      actions taken within the product
                    </li>
                    <li data-id="element-314">
                      <strong data-id="element-315">Technical data:</strong> IP address, browser type,
                      device type, timestamps
                    </li>
                    <li data-id="element-316">
                      <strong data-id="element-317">Cookies and similar technologies:</strong> used
                      for authentication, session management, and basic
                      analytics
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-318">
            <div className="section-head" data-id="element-319">
              <div className="section-num" data-id="element-320">02</div>
              <div className="section-title" data-id="element-321">
                <h2 data-id="element-322">How We Use Information</h2>
                <span className="deck" data-id="element-323">
                  Operating and improving the service.
                </span>
              </div>
            </div>
            <div className="section-body" data-id="element-324">
              <div className="pad" data-id="element-325"></div>
              <div className="content" data-id="element-326">
                <div className="entry" data-id="element-327">
                  <ul style={{
                  margin: '8px 0',
                  paddingLeft: '20px',
                  color: 'var(--ink-2)',
                  fontSize: '15px'
                }} data-id="element-328">
                    <li data-id="element-329">Provide and operate the Service</li>
                    <li data-id="element-330">Authenticate users and manage accounts</li>
                    <li data-id="element-331">Process prompts and generate analytics and insights</li>
                    <li data-id="element-332">Communicate with you about the product</li>
                    <li data-id="element-333">
                      Monitor performance, prevent abuse, and maintain security
                    </li>
                    <li data-id="element-334">Improve features, usability, and reliability</li>
                  </ul>
                  <p style={{
                  marginTop: '16px'
                }} data-id="element-335">
                    <strong data-id="element-336">We do not sell your personal information.</strong>
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-337">
            <div className="section-head" data-id="element-338">
              <div className="section-num" data-id="element-339">03</div>
              <div className="section-title" data-id="element-340">
                <h2 data-id="element-341">Customer Content</h2>
                <span className="deck" data-id="element-342">
                  How we handle your prompts and data.
                </span>
              </div>
            </div>
            <div className="section-body" data-id="element-343">
              <div className="pad" data-id="element-344"></div>
              <div className="content" data-id="element-345">
                <div className="entry" data-id="element-346">
                  <p data-id="element-347">
                    Content you submit to Andoe, such as prompts, queries, and
                    configuration data, is used solely to provide functionality,
                    generate analytics, and operate the Service.
                  </p>
                  <p style={{
                  marginTop: '16px'
                }} data-id="element-348">
                    We do not use your customer content for advertising
                    purposes. You are responsible for ensuring you have the
                    rights to submit any content, including client or
                    third-party data.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-349">
            <div className="section-head" data-id="element-350">
              <div className="section-num" data-id="element-351">04</div>
              <div className="section-title" data-id="element-352">
                <h2 data-id="element-353">Service Providers</h2>
                <span className="deck" data-id="element-354">
                  Third parties that help us operate.
                </span>
              </div>
            </div>
            <div className="section-body" data-id="element-355">
              <div className="pad" data-id="element-356"></div>
              <div className="content" data-id="element-357">
                <div className="entry" data-id="element-358">
                  <p data-id="element-359">
                    We use trusted third-party service providers (hosting,
                    authentication, analytics, payment processors, AI models) to
                    help operate Andoe.
                  </p>
                  <p style={{
                  marginTop: '16px'
                }} data-id="element-360">
                    These providers may process data only as necessary to
                    provide their services to us and are contractually obligated
                    to protect it. Your data may be processed in Canada, the
                    United States, and other jurisdictions where our service
                    providers operate.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-361">
            <div className="section-head" data-id="element-362">
              <div className="section-num" data-id="element-363">05</div>
              <div className="section-title" data-id="element-364">
                <h2 data-id="element-365">Data Security & Retention</h2>
                <span className="deck" data-id="element-366">Protecting and keeping your data.</span>
              </div>
            </div>
            <div className="section-body" data-id="element-367">
              <div className="pad" data-id="element-368"></div>
              <div className="content" data-id="element-369">
                <div className="entry" data-id="element-370">
                  <h3 data-id="element-371">Security</h3>
                  <p data-id="element-372">
                    We implement reasonable administrative, technical, and
                    organizational safeguards designed to protect your
                    information. However, no system is perfectly secure. You are
                    responsible for maintaining the confidentiality of your
                    login credentials.
                  </p>
                </div>
                <div className="entry" data-id="element-373">
                  <h3 data-id="element-374">Retention</h3>
                  <p data-id="element-375">
                    We retain personal information and customer content while
                    your account is active. After account termination, we may
                    retain data for a limited period for legal compliance,
                    security, dispute resolution, or enforcement of our Terms.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-376">
            <div className="section-head" data-id="element-377">
              <div className="section-num" data-id="element-378">06</div>
              <div className="section-title" data-id="element-379">
                <h2 data-id="element-380">Your Rights & Contact</h2>
                <span className="deck" data-id="element-381">Managing your information.</span>
              </div>
            </div>
            <div className="section-body" data-id="element-382">
              <div className="pad" data-id="element-383"></div>
              <div className="content" data-id="element-384">
                <div className="entry" data-id="element-385">
                  <h3 data-id="element-386">Your Rights</h3>
                  <p data-id="element-387">
                    Depending on your location, you may have rights to access
                    your personal information, request correction or deletion,
                    or withdraw consent. You can make requests by contacting us.
                  </p>
                </div>
                <div className="entry" data-id="element-388">
                  <h3 data-id="element-389">Contact</h3>
                  <p data-id="element-390">
                    If you have questions about this Privacy Policy or your
                    data, contact us at:{' '}
                    <a href="mailto:jason@andoe.work" style={{
                    color: 'var(--ink)',
                    textDecoration: 'underline'
                  }} data-id="element-391">
                      jason@andoe.work
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </section>

          <Footer data-id="element-392" />
        </article>

        <pre className="json-view" data-id="element-393">
          {`// privacy policies are for humans, not for AI to parse.
// 
// read the document above. it was written for you.`}
        </pre>
      </main>
    </>;
}